"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualList = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_use_measure_1 = __importDefault(require("react-use-measure"));
const react_virtuoso_1 = require("react-virtuoso");
const ListItem_1 = require("./ListItem");
const ITEM_GAP = 5;
const VirtualList = (props) => {
    const { itemCount, render, itemSize = 30, onItemClicked } = props;
    const [ref, { height }] = (0, react_use_measure_1.default)();
    return (react_1.default.createElement("div", { style: props.style || { flex: 1, height: "100%", width: "100%" }, ref: ref },
        react_1.default.createElement(react_virtuoso_1.Virtuoso, { height: height !== null && height !== void 0 ? height : 1, width: "100%", totalCount: itemCount, defaultItemHeight: itemSize + ITEM_GAP, itemContent: (index, style) => {
                var _a;
                return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                    react_1.default.createElement(ListItem_1.ListItem, { onClick: () => onItemClicked && onItemClicked(index), style: { ...style, height: itemSize }, selected: "selectedIndex" in props
                            ? typeof props.selectedIndex === "function"
                                ? props.selectedIndex(index)
                                : index === ((_a = props.selectedIndex) !== null && _a !== void 0 ? _a : -1)
                            : false }, render(index)),
                    react_1.default.createElement("div", { style: { height: ITEM_GAP, flex: `0 0 ${ITEM_GAP}px` } })));
            } })));
};
exports.VirtualList = VirtualList;
//# sourceMappingURL=index.js.map